<template>
  <div
    class="relative transition-[opacity,transform] duration-300 ease-out active:scale-[98%] md:hover:scale-[98%]"
    :class="[isVisible ? 'scale-100 opacity-100' : 'scale-90 opacity-0']"
  >
    <DealStickerMain :icon>
      <div class="flex grow items-center">
        <div class="body-2-bold grow px-16 py-12">
          <p v-if="$slots.title" class="body-2-bold">
            <slot name="title" />
          </p>
          <p v-if="$slots.description" class="caption mt-4 flex items-center">
            <slot name="description" />
          </p>
        </div>
      </div>
    </DealStickerMain>
  </div>
</template>

<script lang="ts" setup>
import { type Component, onMounted, ref } from 'vue'

import DealStickerMain from './DealStickerMain.vue'

const isVisible = ref(false)

onMounted(() => {
  isVisible.value = true
})

defineProps<{
  icon: Component
}>()
</script>

<style module>
@keyframes slideOnce {
  0% {
    left: -200px;
  }
  100% {
    left: 100%;
  }
}

@keyframes slideInfinite {
  0% {
    left: -200px;
  }
  10%,
  100% {
    left: 100%;
  }
}

.slide {
  background: linear-gradient(
    105deg,
    transparent 15%,
    rgba(255, 255, 255, 0.8) 50%,
    transparent 85%
  );
}

.slideActive {
  animation: slideOnce 700ms;
  animation-delay: 200ms;
  @media (max-width: theme('screens.md')) {
    animation: slideInfinite 7s;
    animation-iteration-count: infinite;
  }
}
</style>
